export default __webpack_public_path__ + "static/media/95_desktop.d8732e51.jpg";